import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta("404 页面不存在 | 今日新瓜", "您访问的页面不存在，欢迎回到今日新瓜首页，探索独家内幕与爆料。");
  return (
    <>
      <Navbar />
      <main className="mx-auto flex min-h-[62vh] max-w-3xl flex-col items-center justify-center px-4 text-center">
        <p className="font-heading text-7xl font-black text-primary-200">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-900">
          这块瓜地里没有你要找的东西
        </h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">
          页面可能已被移动或删除。去首页看看今天又有哪些独家内幕正在发酵吧。
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-full bg-primary-600 px-6 py-2.5 text-sm font-semibold text-background-50 hover:bg-primary-700"
          >
            <i className="ri-home-4-line" /> 回到首页
          </Link>
          <Link
            to="/category/exclusive"
            className="inline-flex items-center gap-2 rounded-full border border-background-300 px-6 py-2.5 text-sm font-medium text-foreground-700 hover:border-primary-300 hover:text-primary-700"
          >
            <i className="ri-flashlight-line" /> 去看独家内幕
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}